export enum Reason {
    SR = "SR - Suspended Regime",
    EC = "EC - Expiring Certificate",
    ZDT = "ZDT - Zero Duty Tariff",
}
